import React from 'react';
import { profile } from '../../data/profil';
const labelClass = 'block text-sm font-semibold text-slate-600';
const fieldClass = 'mt-1.5 w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-[15px] text-ville-navy transition-colors duration-150 ease-ville focus:border-ville-indigo focus:outline-none focus:ring-2 focus:ring-ville-indigo/20';

/** Coordonnées modifiables en tout temps, sans vérification. */
export function ContactInfo() {
  return <section aria-labelledby="contact-titre" className="mt-6 rounded-3xl border border-slate-200 bg-white p-6 sm:p-8" data-id="element-2816" data-mp="3iyucy5mhvmzm">
      <h2 id="contact-titre" className="text-xl font-extrabold tracking-tight text-ville-navy" data-id="element-2817" data-mp="3syl6a3zbjvy4">
        Mes coordonnées
      </h2>
      <form className="mt-6 grid gap-5 sm:grid-cols-2" onSubmit={event => event.preventDefault()} data-id="element-2818" data-mp="1lqhnvg5048w">
        <div className="sm:col-span-2" data-id="element-2819" data-mp="309nyiusqhhjm">
          <label htmlFor="contact-courriel" className={labelClass} data-id="element-2820" data-mp="3590nbl360you">
            Courriel
          </label>
          <input id="contact-courriel" type="email" autoComplete="email" defaultValue={profile.email} className={fieldClass} data-id="element-2821" data-mp="2lmca5cvvxji4" />
        </div>
        <div data-id="element-2822" data-mp="2bwar4zie2ra2">
          <label htmlFor="contact-tel" className={labelClass} data-id="element-2823" data-mp="2bvr6hb1ctosc">
            Téléphone principal
          </label>
          <input id="contact-tel" type="tel" autoComplete="tel" defaultValue={profile.phone} className={fieldClass} data-id="element-2824" data-mp="26wxz80cnuu0m" />
        </div>
        <div data-id="element-2825" data-mp="1xvgdo2ghi04j">
          <label htmlFor="contact-tel-secondaire" className={labelClass} data-id="element-2826" data-mp="1xvq57uh6gfcc">
            Téléphone secondaire (optionnel)
          </label>
          <input id="contact-tel-secondaire" type="tel" defaultValue={profile.phoneSecondary} className={fieldClass} data-id="element-2827" data-mp="1nz3mbb8evycy" />
        </div>
      </form>
    </section>;
}